import React, { useState, useEffect } from 'react';
import './CollegeOfScience.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import { useNavigate } from 'react-router-dom';
   import {Link} from "react-router-dom";
// import { FaFlask, FaDna, FaLeaf, FaAtom, FaCalculator, FaChartLine, FaLightbulb, FaBug, FaBriefcase, FaShoppingCart, FaChartBar, FaBook, FaLanguage, FaLaptopCode } from 'react-icons/fa';
import {
  FaCogs,           // Mechanical Engineering
  FaBrain,          // AI
  FaLaptopCode,     // CSE
  FaBroadcastTower, // ECE
  FaHardHat,        // Civil
  FaUniversity,     // Humanities & Basic Sciences
  FaDna,            // Biotechnology
  FaSeedling,       // Botany
  FaBriefcase,      // Business Management
  FaFlask,          // Chemistry
  FaStore,          // Commerce
  FaDesktop,        // Computer Science
  FaBalanceScale,   // Economics
  FaPenFancy,       // English
  FaAppleAlt,       // Food Science & Nutrition
  FaSquareRootAlt,  // Mathematics
  FaChartPie,       // Statistics
  FaAtom,           // Physics
  FaBookOpen,       // Telugu
  FaBug             // Zoology
} from 'react-icons/fa';
const CollegeOfScience = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('about');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    setIsMobileSidebarOpen(false);
  };

 useEffect(() => {
  const hash = window.location.hash.replace('#', '');

  // If URL has a valid section → open it
  if (hash && sections.some(s => s.id === hash)) {
    setActiveSection(hash);

    setTimeout(() => {
      const element = document.getElementById(`cos-section-${hash}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  } 
  // Otherwise default to About
  else {
    setActiveSection("about");
  }

}, []);   // 🚫 DO NOT remove hash anymore



  const departments = [
    {
      id: 7,
      name: 'Biotechnology',
      icon: FaDna,
      route: '/academics/biotechnology'
    },
    {
      id: 8,
      name: 'Botany',
      icon: FaSeedling,
      route: '/academics/botany'
    },
    {
      id: 9,
      name: 'Business Management',
      icon: FaBriefcase,
      route: '/academics/business-management'
    },
    {
      id: 10,
      name: 'Chemistry',
      icon: FaFlask,
      route: '/academics/chemistry'
    },
    {
      id: 11,
      name: 'Commerce',
      icon: FaStore,
      route: '/academics/commerce'
    },
    {
      id: 12,
      name: 'Computer Science',
      icon: FaDesktop,
      route: '/academics/computer-science'
    },
    {
      id: 13,
      name: 'Economics',
      icon: FaBalanceScale,
      route: '/academics/economics'
    },
    {
      id: 14,
      name: 'English',
      icon: FaPenFancy,
      route: '/academics/english'
    },
    {
      id: 15,
      name: 'Food Science and Nutrition',
      icon: FaAppleAlt,
      route: '/academics/food-science'
    },
    {
      id: 16,
      name: 'Mathematics',
      icon: FaSquareRootAlt,
      route: '/academics/mathematics'
    },
    {
      id: 17,
      name: 'Statistics (OR & SQC)',
      icon: FaChartPie,
      route: '/academics/statistics'
    },
    {
      id: 18,
      name: 'Physics',
      icon: FaAtom,
      route: '/academics/physics'
    },
    {
      id: 19,
      name: 'Telugu',
      icon: FaBookOpen,
      route: '/academics/telugu'
    },
    {
      id: 20,
      name: 'Zoology',
      icon: FaBug,
      route: '/academics/zoology'
    }
  ];

  const sections = [
    { id: 'about', label: 'About' },
    { id: 'principal', label: 'Principal' },

    { id: 'departments', label: 'Departments' },
    { id: 'events', label: 'Events & Achievements' },
    { id: 'administration', label: 'Administration' }
  ];

  return (
    <>
      <Navbar />
      <div className="cos-page-container">
        {/* Banner */}
        <div className="cos-banner">
          <img
            src="/campuslife/college/lifesciencebuilding.JPG"
            alt="College of Science"
            className="cos-banner-image"
          />
          <div className="cos-banner-overlay">
            <h1 className="cos-banner-title">College of Science</h1>
          </div>
        </div>

        <div className="cos-content-wrapper">
          {/* Mobile Sidebar Toggle */}
          <button
            className="cos-mobile-sidebar-toggle"
            onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          >
            {isMobileSidebarOpen ? '✕' : '☰'} Navigation
          </button>

          {/* Vertical Navigation Sidebar */}
          <aside className={`cos-sidebar ${isMobileSidebarOpen ? 'cos-sidebar-open' : ''}`}>
            <div className="cos-sidebar-header">
              <h3>Quick Links</h3>
            </div>
            <nav className="cos-sidebar-nav">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`cos-nav-item ${activeSection === section.id ? 'cos-nav-item-active' : ''}`}
                  onClick={() => handleSectionClick(section.id)}
                >
                  {section.label}
                </button>
              ))}
            </nav>
          </aside>

          {/* Main Content Area */}
          <main className="cos-main-content">
         

            {/* About Section */}
            {activeSection === 'about' && (
              <section id="cos-section-about" className="cos-content-section">
                <h2 className="cos-section-title">University College</h2>

                <div className="cos-section-card">

                  {/* ===== Vice Chancellor Card (TOP) ===== */}
                  <div className="cos-vc-card">
                    <img
                      src="/person/vicechancellor2.JPG"
                      alt="Prof. V. Venkata Basava Rao"
                      className="cos-vc-image"
                    />

                    <div className="cos-vc-info">
                      <h3>Prof. V. Venkata Basava Rao</h3>
                      <p className="cos-vc-position">Hon'ble Vice Chancellor</p>
                      <p className="cos-vc-sub">Rayalaseema University</p>

                      <Link
                        to="/about/vc-message"
                        className="cos-vc-btn"
                      >
                        View Message
                      </Link>
                    </div>
                  </div>

                  {/* ===== About Text ===== */}
                  <p className="cos-section-text">
                    The University College at Rayalaseema University is a premier institution
                    dedicated to excellence in scientific education and research.
                  
                    Our state-of-the-art laboratories, experienced faculty, and research
                    facilities provide students with an environment conducive to academic
                    growth and scientific exploration.
                  </p>

                  <div className="cos-highlights">
                    <h3 className="cos-highlights-title">Key Highlights:</h3>
                    <ul className="cos-highlights-list">
                      <li>14 departments offering diverse programs</li>
                      <li>Well-equipped laboratories</li>
                      <li>Experienced faculty</li>
                      <li>Active research culture</li>
                      <li>Seminars & workshops</li>
                      <li>Placement support</li>
                    </ul>
                  </div>

                </div>
              </section>
            )}


            {/* Principal Section */}
            {activeSection === 'principal' && (
              <section id="cos-section-principal" className="cos-content-section">
                <h2 className="cos-section-title">Principal</h2>

                {/* Principal Card */}
                <div className="cos-section-card cos-principal-card">
                  <div className="cos-principal-header">
                    <div className="cos-principal-photo">
                      <img src="/businessmanagement/prof vishwanath reddy.png" alt="Principal" />
                    </div>
                    <div className="cos-principal-info">
                      <h3 className="cos-principal-name">Prof. C. Viswanatha Reddy</h3>
                      <p className="cos-principal-designation">Principal (University College)</p>
                      <p className="cos-principal-qualification">M.Com., MBA, M.Phil., Ph.D.</p>
                      <p className="cos-principal-specialization"><strong>Specialization:</strong> Finance, Accounting, Quantitatives, Predictive Analytics</p>
                      <div className="cos-principal-contact">
                        <p><strong>Email:</strong> <a href="mailto:vsrits@gmail.com">vsrits@gmail.com</a></p>
                        <p><strong>Mobile:</strong> 9848263463</p>
                      </div>
                    </div>
                  </div>
                  <div className="cos-principal-message">
                    <h4>Message from Principal</h4>
                    <p>
                      Welcome to the College of Science at Rayalaseema University. It is my privilege to lead this esteemed institution
                      that has been at the forefront of scientific education and research. Our college is committed to nurturing young minds,
                      fostering innovation, and contributing to the advancement of knowledge in various scientific disciplines.
                    </p>
                    <p>
                      We believe in providing our students with not just theoretical knowledge, but also practical skills and research experience
                      that will prepare them for successful careers in academia, industry, and research organizations. I invite you to explore
                      the various opportunities available at our college and be part of our journey towards excellence.
                    </p>
                  </div>
                </div>
              </section>
            )}

            {/* Vice Principal Section */}
            {activeSection === 'vice-principal' && (
              <section id="cos-section-vice-principal" className="cos-content-section">
                <h2 className="cos-section-title">Vice Principal</h2>

                {/* Vice Principal Card */}
                <div className="cos-section-card cos-principal-card">
                  <div className="cos-principal-header">
                    <div className="cos-principal-photo">
                      <img src="/person/Narasimhulu.jpg" alt="Vice Principal" />
                    </div>
                    <div className="cos-principal-info">
                      <h3 className="cos-principal-name">Prof. N. Narasimhulu</h3>
                      <p className="cos-principal-designation">Vice Principal (University College)</p>
                      <p className="cos-principal-qualification">M.Sc., Ph.D.</p>
                      <p className="cos-principal-specialization"><strong>Specialization:</strong> Telugu</p>
                      <div className="cos-principal-contact">
                        <p><strong>Email:</strong> <a href="mailto:viceprincipal@ruk.ac.in">viceprincipal@ruk.ac.in</a></p>
                        <p><strong>Mobile:</strong> +91-9182034667</p>
                      </div>
                    </div>
                  </div>
                  <div className="cos-principal-message">
                    <h4>Message from Vice Principal</h4>
                    <p>
                      As Vice Principal of the College of Science, I am honored to work alongside our dedicated faculty and talented students
                      in pursuing academic excellence and research innovation. Our college provides a nurturing environment where students can
                      develop their intellectual capabilities and prepare for future challenges.
                    </p>
                    <p>
                      We are committed to maintaining high academic standards while ensuring holistic development of our students through
                      co-curricular activities, research opportunities, and industry interactions. I encourage all students to make the most
                      of the resources and opportunities available at our college.
                    </p>
                  </div>
                </div>
              </section>
            )}

            {/* Departments Section */}
            {activeSection === 'departments' && (
              <section id="cos-section-departments" className="cos-content-section">
                <h2 className="cos-section-title">Departments</h2>
                <div className="cos-departments-grid">
                  {departments.map((dept, index) => {
                    const IconComponent = dept.icon;
                    return (
                      <div
                        key={index}
                        className="cos-department-card"
                        onClick={() => navigate(dept.route)}
                      >
                        <div className="cos-department-icon">
                          <IconComponent />
                        </div>
                        <div className="cos-department-info">
                          <h3 className="cos-department-name">{dept.name}</h3>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>
            )}

            {/* Events & Achievements Section */}
            {activeSection === 'events' && (
              <section id="cos-section-events" className="cos-content-section">
                <h2 className="cos-section-title">Events & Achievements</h2>
                {/* <div className="cos-events-grid">
                  <div className="cos-event-card">
                    <div className="cos-event-type">Workshop</div>
                    <h3 className="cos-event-title">National Science Day Celebration</h3>
                    <p className="cos-event-date">February 28, 2024</p>
                    <p className="cos-event-description">
                      The college organized a grand celebration of National Science Day with various activities including 
                      poster presentations, science exhibitions, and guest lectures by eminent scientists.
                    </p>
                  </div>

                  <div className="cos-event-card">
                    <div className="cos-event-type">Achievement</div>
                    <h3 className="cos-event-title">Research Excellence Award</h3>
                    <p className="cos-event-date">January 2024</p>
                    <p className="cos-event-description">
                      Faculty members from the Department of Chemistry received the prestigious Research Excellence Award 
                      for their groundbreaking work in green chemistry and sustainable materials.
                    </p>
                  </div>

                  <div className="cos-event-card">
                    <div className="cos-event-type">Seminar</div>
                    <h3 className="cos-event-title">International Conference on Applied Sciences</h3>
                    <p className="cos-event-date">March 15-17, 2024</p>
                    <p className="cos-event-description">
                      The college successfully hosted an international conference with participation from researchers 
                      across the globe, featuring keynote addresses and technical sessions on cutting-edge research.
                    </p>
                  </div>

                  <div className="cos-event-card">
                    <div className="cos-event-type">Achievement</div>
                    <h3 className="cos-event-title">Student Research Paper Publication</h3>
                    <p className="cos-event-date">December 2023</p>
                    <p className="cos-event-description">
                      Multiple students from various departments published their research papers in prestigious international 
                      journals, showcasing the quality of research conducted at the college.
                    </p>
                  </div>

                  <div className="cos-event-card">
                    <div className="cos-event-type">Competition</div>
                    <h3 className="cos-event-title">Inter-Collegiate Science Quiz</h3>
                    <p className="cos-event-date">November 2023</p>
                    <p className="cos-event-description">
                      Students from the College of Science won first prize in the inter-collegiate science quiz competition 
                      held at the state level, demonstrating their excellence in scientific knowledge.
                    </p>
                  </div>

                  <div className="cos-event-card">
                    <div className="cos-event-type">Workshop</div>
                    <h3 className="cos-event-title">Faculty Development Program</h3>
                    <p className="cos-event-date">October 2023</p>
                    <p className="cos-event-description">
                      A comprehensive faculty development program was organized focusing on modern teaching methodologies, 
                      research techniques, and academic leadership.
                    </p>
                  </div>
                </div> */}
              </section>
            )}

            {/* Administration Section */}
            {activeSection === 'administration' && (
              <section id="cos-section-administration" className="cos-content-section">
                <h2 className="cos-section-title">
                  University College – Principal Office (Administration)
                </h2>

                <div className="cos-section-card">
                  <div className="cos-table-wrapper">
                    <table className="cos-admin-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name of the Employee</th>
                          <th>Designation</th>
                          <th>Phone Number</th>
                          <th>Email ID</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>Dr. M. Syamala Sarojini</td>
                          <td>Assistant Registrar</td>
                          <td>8978171494</td>
                          <td>SYAMALASAROJINI1@gmail.com</td>
                        </tr>

                        <tr>
                          <td>2</td>
                          <td>Mr. K. Jayaraju</td>
                          <td>Gardener</td>
                          <td>9963323402</td>
                          <td>—</td>
                        </tr>

                        <tr>
                          <td>3</td>
                          <td>G. Ramadevi</td>
                          <td>Office Assistant</td>
                          <td>9441010583</td>
                          <td>avijabindu@gmail.com</td>
                        </tr>

                        <tr>
                          <td>4</td>
                          <td>Smt. V. Mamatha Jessica</td>
                          <td>Office Assistant</td>
                          <td>9491434124</td>
                          <td>jessicamamatha123@gmail.com</td>
                        </tr>

                        <tr>
                          <td>5</td>
                          <td>Mr. A. Venu Gopal</td>
                          <td>Gardener</td>
                          <td>9866353639</td>
                          <td>—</td>
                        </tr>

                        <tr>
                          <td>6</td>
                          <td>Smt. M. Rangamma</td>
                          <td>Sweeper</td>
                          <td>9618080291</td>
                          <td>—</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            )}


          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CollegeOfScience;
